export default function PublicProfileScreen() {
  return null;
}